const node = document.querySelector('.react-app-root');

const scrollUp = () => {
  node?.scrollIntoView({ block: 'start' });

  return { type: '#scroll-up-page' };
};

export { scrollUp };
